import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component - ensures page scrolls to top on route change
 * Must be placed inside BrowserRouter
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
